module.exports = __webpack_public_path__ + "static/media/king-edward-zishume.d5a6f8e1.jpg";